const CART_INTERCEPTOR_ENDPOINTS = ['/cart/add', '/cart/update', '/cart/change', '/cart/clear'];

/* -----------------------
   HELPERS
-------------------------*/
function isCartInterceptorUrl(url) {
  if (!url) return false;
  const clean = url.replace(window.location.origin, '');
  return CART_INTERCEPTOR_ENDPOINTS.some((ep) => clean.startsWith(ep));
}

function cartInterceptorPublishEvent(url, data = {}) {
  const clean = url.replace(window.location.origin, '').split('?')[0];
  const key = clean.replace(/\/cart\/|\.js/g, '');
  const eventName = PUB_SUB_EVENTS.cartInterceptor[key];

  if (eventName) {
    publish(eventName, data);
  }
}

/* -----------------------
   XHR INTERCEPTOR
-------------------------*/
(function () {
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartMethod = method;
    this._cartUrl = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    this.addEventListener('load', () => {
      if (isCartInterceptorUrl(this._cartUrl)) {
        cartInterceptorPublishEvent(this._cartUrl, {
          method: this._cartMethod,
          body: body,
          url: this._cartUrl,
        });
      }
    });

    return origSend.apply(this, arguments);
  };
})();

/* -----------------------
   FETCH INTERCEPTOR
-------------------------*/
(function () {
  const origFetch = window.fetch;

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input.url;

    return origFetch(input, init).then((response) => {
      if (isCartInterceptorUrl(url)) {
        cartInterceptorPublishEvent(url, {
          method: (init && init.method) || 'GET',
          body: (init && init.body) || null,
          url: url,
        });
      }
      return response;
    });
  };
})();
